class MainSearch extends SearchForm {
    constructor() {
        super();
        console.log("MainSearch constructor called");
        this.allSearchInputs = document.querySelectorAll(
            'input[type="search"]'
        );
        this.init();
    }

    async init() {
        console.log("MainSearch init started");
        try {
            // Wait for all required elements to be available
            this.yearInput = await this.waitForElement("#year-input");
            this.makeInput = await this.waitForElement("#make-input");
            this.modelInput = await this.waitForElement("#model-input");
            this.productInput = await this.waitForElement("#product-input");

            console.log("Desktop elements found:", {
                year: this.yearInput,
                make: this.makeInput,
                model: this.modelInput,
                product: this.productInput
            });

            try {
                this.mobileYearInput = await this.waitForElement("#mobile-year-input");
                this.mobileMakeInput = await this.waitForElement("#mobile-make-input");
                this.mobileModelInput = await this.waitForElement("#mobile-model-input");
                this.mobileProductInput = await this.waitForElement("#mobile-product-input");

                console.log("Mobile elements found:", {
                    year: this.mobileYearInput,
                    make: this.mobileMakeInput,
                    model: this.mobileModelInput,
                    product: this.mobileProductInput
                });
            } catch (error) {
                console.error("Error finding mobile elements:", error);
            }

            // Get both desktop and mobile search inputs
            this.desktopSearchInput = document.querySelector('#Search-In-Header');
            this.mobileSearchInput = document.querySelector('#Search-In-Modal');

            console.log("Search inputs found:", {
                desktop: this.desktopSearchInput,
                mobile: this.mobileSearchInput
            });

            // Get both search forms
            this.desktopSearchForm = this.desktopSearchInput?.closest('form');
            this.mobileSearchForm = this.mobileSearchInput?.closest('form');

            console.log("Search forms found:", {
                desktop: this.desktopSearchForm,
                mobile: this.mobileSearchForm
            });

            this.setupEventListeners();
            this.fillFromUrlParams();
        } catch (error) {
            console.error("Error in MainSearch init:", error);
        }
    }

    waitForElement(selector, timeout = 5000) {
        console.log("Waiting for element:", selector);
        return new Promise((resolve, reject) => {
            const element = document.querySelector(selector);
            if (element) {
                console.log("Element found immediately:", selector);
                resolve(element);
                return;
            }

            console.log("Element not found immediately, setting up observer for:", selector);
            const observer = new MutationObserver((mutations, obs) => {
                const element = document.querySelector(selector);
                if (element) {
                    console.log("Element found by observer:", selector);
                    obs.disconnect();
                    resolve(element);
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });

            // Set timeout to prevent infinite waiting
            setTimeout(() => {
                observer.disconnect();
                console.log("Timeout waiting for element:", selector);
                reject(
                    new Error(
                        `Element ${selector} not found after ${timeout}ms`
                    )
                );
            }, timeout);
        });
    }

    setupEventListeners() {
        let allSearchForms = [];
        this.allSearchInputs.forEach((input) =>
            allSearchForms.push(input.form)
        );

        // Add focus event listeners to both desktop and mobile search inputs
        if (this.desktopSearchInput) {
            this.desktopSearchInput.addEventListener("focus", this.onInputFocus.bind(this));
        }
        if (this.mobileSearchInput) {
            this.mobileSearchInput.addEventListener("focus", this.onInputFocus.bind(this));
        }

        // Add submit event listeners to both forms
        if (this.desktopSearchForm) {
            this.desktopSearchForm.addEventListener("submit", this.onFormSubmit.bind(this));
        }
        if (this.mobileSearchForm) {
            this.mobileSearchForm.addEventListener("submit", this.onFormSubmit.bind(this));
        }

        if (allSearchForms.length < 2) return;
        allSearchForms.forEach((form) =>
            form.addEventListener("reset", this.onFormReset.bind(this))
        );
        this.allSearchInputs.forEach((input) =>
            input.addEventListener("input", this.onInput.bind(this))
        );

        // Add event listeners for desktop year, make, model, and product inputs
        if (this.yearInput)
            this.yearInput.addEventListener(
                "input",
                (e) => this.onFieldInput(e, 'desktop')
            );
        if (this.makeInput)
            this.makeInput.addEventListener(
                "input",
                (e) => this.onFieldInput(e, 'desktop')
            );
        if (this.modelInput)
            this.modelInput.addEventListener(
                "input",
                (e) => this.onFieldInput(e, 'desktop')
            );
        if (this.productInput)
            this.productInput.addEventListener(
                "input",
                (e) => this.onFieldInput(e, 'desktop')
            );

        // Add event listeners for mobile year, make, model, and product inputs
        if (this.mobileYearInput)
            this.mobileYearInput.addEventListener(
                "input",
                (e) => this.onFieldInput(e, 'mobile')
            );
        if (this.mobileMakeInput)
            this.mobileMakeInput.addEventListener(
                "input",
                (e) => this.onFieldInput(e, 'mobile')
            );
        if (this.mobileModelInput)
            this.mobileModelInput.addEventListener(
                "input",
                (e) => this.onFieldInput(e, 'mobile')
            );
        if (this.mobileProductInput)
            this.mobileProductInput.addEventListener(
                "input",
                (e) => this.onFieldInput(e, 'mobile')
            );
    }

    onFormSubmit(event) {
        event.preventDefault();

        // Build search query from all fields
        let searchTerms = [];
        if (this.yearInput && this.yearInput.value)
            searchTerms.push(`"${this.yearInput.value}"`);
        if (this.makeInput && this.makeInput.value)
            searchTerms.push(`"Make_${this.makeInput.value}"`);
        if (this.modelInput && this.modelInput.value)
            searchTerms.push(`"Model_${this.modelInput.value}"`);
        if (this.productInput && this.productInput.value)
            searchTerms.push(this.productInput.value);

        const searchQuery = searchTerms.join(" ");

        // Update both search inputs with the final query
        if (this.desktopSearchInput) this.desktopSearchInput.value = searchQuery;
        if (this.mobileSearchInput) this.mobileSearchInput.value = searchQuery;

        // Submit the form that triggered the event
        event.target.submit();
    }

    onFormReset(event) {
        super.onFormReset(event);
        if (super.shouldResetForm()) {
            this.keepInSync("", this.input);
            // Reset all field inputs
            if (this.yearInput) this.yearInput.value = "";
            if (this.makeInput) this.makeInput.value = "";
            if (this.modelInput) this.modelInput.value = "";
            if (this.productInput) this.productInput.value = "";
            if (this.mobileYearInput) this.mobileYearInput.value = "";
            if (this.mobileMakeInput) this.mobileMakeInput.value = "";
            if (this.mobileModelInput) this.mobileModelInput.value = "";
            if (this.mobileProductInput) this.mobileProductInput.value = "";
        }
    }

    onInput(event) {
        const target = event.target;
        this.keepInSync(target.value, target);
    }

    onFieldInput(event, source) {
        const target = event.target;
        const value = target.value;

        // Sync the corresponding field in the other view
        if (source == 'desktop') {
            if (target == this.yearInput && this.mobileYearInput) this.mobileYearInput.value = value;
            if (target == this.makeInput && this.mobileMakeInput) this.mobileMakeInput.value = value;
            if (target == this.modelInput && this.mobileModelInput) this.mobileModelInput.value = value;
            if (target == this.productInput && this.mobileProductInput) this.mobileProductInput.value = value;
        } else {
            if (target == this.mobileYearInput && this.yearInput) this.yearInput.value = value;
            if (target == this.mobileMakeInput && this.makeInput) this.makeInput.value = value;
            if (target == this.mobileModelInput && this.modelInput) this.modelInput.value = value;
            if (target == this.mobileProductInput && this.productInput) this.productInput.value = value;
        }
        console.log(source);

        // Update the main search input with combined values
        let searchTerms = [];
        const yearValue = source == 'desktop' ? this.yearInput?.value : this.mobileYearInput?.value;
        const makeValue = source == 'desktop' ? this.makeInput?.value : this.mobileMakeInput?.value;
        const modelValue = source == 'desktop' ? this.modelInput?.value : this.mobileModelInput?.value;
        const productValue = source == 'desktop' ? this.productInput?.value : this.mobileProductInput?.value;

        if (yearValue) searchTerms.push(`"${yearValue}"`);
        if (makeValue) searchTerms.push(`"Make_${makeValue}"`);
        if (modelValue) searchTerms.push(`"Model_${modelValue}"`);
        if (productValue) searchTerms.push(productValue);

        const searchValue = searchTerms.join(" ");

        // Update both search inputs
        if (this.desktopSearchInput) this.desktopSearchInput.value = searchValue;
        if (this.mobileSearchInput) this.mobileSearchInput.value = searchValue;
    }

    onInputFocus() {
        const isSmallScreen = window.innerWidth < 750;
        if (isSmallScreen) {
            this.scrollIntoView({ behavior: "smooth" });
        }
    }

    keepInSync(value, target) {
        // Sync all search inputs including desktop and mobile
        this.allSearchInputs.forEach((input) => {
            if (input !== target) {
                input.value = value;
            }
        });

        // Also sync the desktop and mobile search inputs
        if (this.desktopSearchInput && this.desktopSearchInput !== target) {
            this.desktopSearchInput.value = value;
        }
        if (this.mobileSearchInput && this.mobileSearchInput !== target) {
            this.mobileSearchInput.value = value;
        }
    }

    fillFromUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const garageSearch = urlParams.get("garage-search");
        if (!garageSearch) {
            const rawQuery = urlParams.get("q");
            // Split on spaces that are not within quotes
            const searchTerm = rawQuery.match(/"([^"]*)"|\S+/g) || [];

            var year, make, model, product;

            // Check first three terms if they exist
            if (searchTerm.length > 0) {
                const firstTerm = searchTerm[0];
                const isYear = /^"\d{4}"$/.test(firstTerm);
                if (isYear && this.yearInput) {
                    year = firstTerm.replace(/"/g, "");
                }
            }

            if (searchTerm.length > 1) {
                const secondTerm = searchTerm[1];
                const isMake =
                    secondTerm.startsWith('"Make_') && secondTerm.endsWith('"');
                if (isMake && this.makeInput) {
                    make = secondTerm.replace(/^"Make_|"$/g, "");
                }
            }

            if (searchTerm.length > 2) {
                const thirdTerm = searchTerm[2];
                const isModel =
                    thirdTerm.startsWith('"Model_') && thirdTerm.endsWith('"');
                if (isModel && this.modelInput) {
                    model = thirdTerm.replace(/^"Model_|"$/g, "");
                }
            }

            if (searchTerm.length > 3) {
                product = searchTerm.slice(3).join(" ");
            }

            if (year) {
                // Wait for vehicle data to be loaded
                const waitForVehicleData = setInterval(() => {
                    if (window.vehicleData) {
                        clearInterval(waitForVehicleData);

                        this.yearInput.disabled = false;
                        this.yearInput.value = year;
                        // Trigger year change to populate make options
                        this.yearInput.dispatchEvent(
                            new Event("change", { bubbles: true })
                        );

                        // Wait for make options to be populated
                        const waitForMakeOptions = setInterval(() => {
                            const options = Array.from(this.makeInput.options);
                            if (options.length > 1) {
                                // More than just the default option
                                clearInterval(waitForMakeOptions);

                                if (make && this.makeInput) {
                                    // Enable make input
                                    this.makeInput.disabled = false;

                                    // Find the option that contains the make value
                                    const makeOption = options.find(
                                        (option) =>
                                            option.textContent
                                                .toLowerCase()
                                                .includes(make.toLowerCase()) ||
                                            option.value
                                                .toLowerCase()
                                                .includes(make.toLowerCase())
                                    );

                                    if (makeOption) {
                                        makeOption.selected = true;
                                        // Trigger make change to populate model options
                                        this.makeInput.dispatchEvent(
                                            new Event("change", {
                                                bubbles: true,
                                            })
                                        );

                                        // Wait for model options to be populated
                                        const waitForModelOptions = setInterval(
                                            () => {
                                                const modelOptions = Array.from(
                                                    this.modelInput.options
                                                );
                                                if (modelOptions.length > 1) {
                                                    // More than just the default option
                                                    clearInterval(
                                                        waitForModelOptions
                                                    );

                                                    if (
                                                        model &&
                                                        this.modelInput
                                                    ) {
                                                        // Enable model input
                                                        this.modelInput.disabled = false;

                                                        // Find the option that contains the model value
                                                        const modelOption =
                                                            modelOptions.find(
                                                                (option) =>
                                                                    option.textContent
                                                                        .toLowerCase()
                                                                        .includes(
                                                                            model.toLowerCase()
                                                                        ) ||
                                                                    option.value
                                                                        .toLowerCase()
                                                                        .includes(
                                                                            model.toLowerCase()
                                                                        )
                                                            );

                                                        if (modelOption) {
                                                            modelOption.selected = true;
                                                            // Trigger model change
                                                            this.modelInput.dispatchEvent(
                                                                new Event(
                                                                    "change",
                                                                    {
                                                                        bubbles: true,
                                                                    }
                                                                )
                                                            );
                                                        } else {
                                                            console.log(
                                                                "No model option found for:",
                                                                model
                                                            );
                                                        }
                                                    }
                                                }
                                            },
                                            100
                                        );

                                        // Clear interval after 5 seconds if options never appear
                                        setTimeout(
                                            () =>
                                                clearInterval(
                                                    waitForModelOptions
                                                ),
                                            5000
                                        );
                                    } else {
                                        console.log(
                                            "No make option found for:",
                                            make
                                        );
                                        console.log(
                                            "Available options:",
                                            options.map(
                                                (opt) => opt.textContent
                                            )
                                        );
                                    }
                                }
                            }
                        }, 100);

                        // Clear interval after 5 seconds if options never appear
                        setTimeout(
                            () => clearInterval(waitForMakeOptions),
                            5000
                        );
                    }
                }, 100);

                // Clear interval after 10 seconds if vehicle data never loads
                setTimeout(() => clearInterval(waitForVehicleData), 10000);

                document.getElementById("year-label").textContent = year;
                document.getElementById("make-label").textContent = make;
                document.getElementById("model-label").textContent = model;
            } else {
                document.getElementById("ymm-search-label").style.display =
                    "none";
            }
            if (product) this.productInput.value = product;

            document.getElementById("product-label").textContent = product;
        } else {
            const rawQuery = urlParams.get("q");
            document.getElementById("ymm-search-label").textContent = rawQuery;
        }
    }
}

customElements.define("main-search", MainSearch);
